import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  GlobalMessageService,
  GlobalMessageType,
  OccEndpointsService,
  TranslationService,
} from '@spartacus/core';
import { Observable } from 'rxjs';
import { first, map, take, tap } from 'rxjs/operators';
import { ManufacturerMapping } from '../custom-manufacturer-campaign/custom-manufacturer-campaign.models';
import { CustomVendorReportingDetailsComponent } from './components/custom-vendor-reporting-details/custom-vendor-reporting-details.component';
import { CustomVendorReportingInstructionsComponent } from './components/custom-vendor-reporting-instructions/custom-vendor-reporting-instructions.component';
import { CustomVendorReportingAdapter } from './custom-vendor-reporting.adapter';
import {
  CustomVendorReportingSearchFilters,
  ReportTransferType,
  VendorReportTransferData,
  VendorReportingDetailResultsData,
} from './custom-vendor-reporting.models';
import { HttpClient } from '@angular/common/http';
import { UigExportComponent } from 'src/app/components/uig-export/uig-export.component';
import {formatDate} from '@angular/common';
import { Branch } from 'src/app/organization/uig-branches/uig-branches.models';
@Injectable({
  providedIn: 'root',
})
export class CustomVendorReportingService {
  private reportTransferData: VendorReportTransferData;
  private isRioEmployee: boolean;

  private readonly IMPORT_MESSAGES_KEY_PREFIX = 'customVendorReporting.import.messages.';

  get getReportTransferData() {
    return this.reportTransferData;
  }

  constructor(
    private vendorReportingAdapter: CustomVendorReportingAdapter,
    private modalService: NgbModal,
    private translation: TranslationService,
    private messageService: GlobalMessageService,
    private httpClient: HttpClient,
    private endpoints: OccEndpointsService,
  ) {}
  get getIsRioEmployee() {
    return this.isRioEmployee;
  }
  public getManufacturerMappings(): Observable<ManufacturerMapping[]> {
    return this.vendorReportingAdapter
      .getManufacturerMappingList()
      .pipe(map((manufacturers) => manufacturers.responses));
  }

  public getBranchesList(): Observable<Branch[]> {
    return this.vendorReportingAdapter
      .getBranchesList()
      .pipe(map((branchesList) => branchesList.branches));
  }

  public openDetails(reportTransferData: VendorReportTransferData,isRioEmployee:boolean) {
    this.reportTransferData = reportTransferData;
    this.isRioEmployee= isRioEmployee;
    const modalRef = this.modalService.open(
      CustomVendorReportingDetailsComponent,
      { centered: true, scrollable: true, size: 'customSize' }
    );
    modalRef.componentInstance.reportTransferData = reportTransferData;
    return modalRef;
  }

  openInstructions() {
    this.modalService.open(CustomVendorReportingInstructionsComponent, {
      centered: true,
      size: 'lg',
    });
  }

  importFile(file: File): Observable<VendorReportingDetailResultsData[]> {
    return this.vendorReportingAdapter.uploadVendorReportDetailsFile(file).pipe(
      tap((data) => {
        this.showMessage(data);
      })
    );
  }

  showMessage(messages: VendorReportingDetailResultsData[]) {
    const SHOW_MSG_TIMEOUT_INFO = 600000; // 10 minutes
    if (!messages || (messages && messages.length < 1)) {
      this.translation
        .translate(this.IMPORT_MESSAGES_KEY_PREFIX + 'success')
        .pipe(first())
        .subscribe((text) => {
          this.messageService.add(
            text,
            GlobalMessageType.MSG_TYPE_INFO,
            SHOW_MSG_TIMEOUT_INFO
          );
        });
      return;
    }

    const errorMessage = messages[0];
      this.translation
        .translate(this.IMPORT_MESSAGES_KEY_PREFIX + errorMessage.messageKey, {
          productCode: errorMessage.productCode,
          inventoryDate: errorMessage.inventoryDate
        })
        .pipe(first())
        .subscribe((text) => {
          this.messageService.add(
            text,
            GlobalMessageType.MSG_TYPE_ERROR,
            SHOW_MSG_TIMEOUT_INFO
          );
        });
  }

  exportRioData(formData: CustomVendorReportingSearchFilters):void {
    this.modalService.open(UigExportComponent, { centered: true }).result.then(
      (result) => {
        if (result === 'print') {
          window.print();
        } else {
          this.exportRioEvaluationData(result,formData);
        }
      },
      (reason) => {}
    );
  }

  exportRioEvaluationData(
    selectExport: string,
    formData: CustomVendorReportingSearchFilters
  ) {
    this.translation
      .translate('customVendorReporting.downloadInfo')
      .pipe(take(1))
      .subscribe((message) => {
        this.messageService.add(message, GlobalMessageType.MSG_TYPE_INFO);
      });
    const url = this.endpoints.buildUrl('customRioDataExport', {queryParams: {
      selectExport,
  }} );
    var fileNameLoc ='vendorreport'
    this.httpClient
      .post(url, formData, { observe: 'body', responseType: 'blob' })
      .pipe(
        tap(
          (data) => {
            this.translation
              .translate(fileNameLoc)
              .pipe(take(1))
              .subscribe((fileName) => {
                const currentDate: Date = new Date();
                const formattedDate: string = formatDate(currentDate, 'yyyy-MM-dd',"en-US");
                if (formData.reportTransferType===ReportTransferType[ReportTransferType.Sales]){
                  fileName=formattedDate+'_VendorReportingDatenbewertung_Sales';
                }else{
                  fileName=formattedDate+'_VendorReportingDatenbewertung_Inventory';
                }
                var a = document.createElement('a');
                a.setAttribute('download',  fileName + '.' + selectExport);
                a.href = URL.createObjectURL(data);
                a.click();
              });
          },
          () => {
            this.translation
              .translate('customVendorReporting.errorExportDataEvaluation')
              .pipe(take(1))
              .subscribe((message) => {
                this.messageService.add(
                  message,
                  GlobalMessageType.MSG_TYPE_ERROR
                );
              });
          }
        )
      )
      .subscribe((res) => {});
  }
}
